import { gql } from "@apollo/client";

export const GET_ASSET_INTENSITY = gql`
    query GetAssetIntensity($assetId: ID!, $from: DateTime!, $to: DateTime!) {
        getIntensity(assetId: $assetId, from: $from, to: $to) {
            to
            from
            value
            unit
            area
            breakdown {
                factors {
                    unit
                    to
                    supplierName
                    source
                    note
                    id
                    from
                    factor
                }
                consumption {
                    value
                    unit
                    type
                }
            }
        }
    }
`;

export const GET_ASSET_INTENSITY_CHAT_DATA = gql`
    query getAssetIntensityChartData(
        $assetId: ID!
        $categories: [CrremCategory!]!
    ) {
        getIntensityChartData(assetId: $assetId) {
            year
            energyIntensity
            emissionIntensity
            projectedEmissionIntensity
            projectedEnergyIntensity
        }
        getCrremPathways(
            categories: $categories
            countries: "DK"
            versions: "v203"
        ) {
            color
            value
            year
            unit
            version
            crremCategory
        }
    }
`;
